export function initializeModals() {
    document.querySelectorAll('[data-dialog-id]').forEach(trigger => {
        const dlg = document.getElementById(trigger.dataset.dialogId);
        if (!dlg) return;
        trigger.addEventListener('click', e => { e.preventDefault(); dlg.showModal(); });
        dlg.addEventListener('click', e => {
            const r = dlg.getBoundingClientRect();
            const inside = e.clientX >= r.left && e.clientX <= r.right &&
                e.clientY >= r.top && e.clientY <= r.bottom;
            if (!inside) dlg.close();
        });
        dlg.addEventListener('close', () => trigger.focus());
    });
}


